import React, { Fragment } from "react";
import Header from "../../../components/Header/Header";
import PageTitle from "../../../components/pagetitle/PageTitle";
import Scrollbar from "../../../components/scrollbar/scrollbar";
import Footer from "../../../components/footer/Footer";
import img13 from "../../../images/service/webapp/ios apps.png";
import ServiceHero from "../components/ServiceHero";
import ServiceJourney from "../components/ServiceJourney";
import ServiceCapabilities from "../components/ServiceCapabilities";
import ServiceResults from "../components/ServiceResults";
import ServiceOutcomes from "../components/ServiceOutcomes";
import ServiceWhyChooseUs from "../components/ServiceWhyChooseUs";
import FaqSection from "../../../components/PageSection/FAQsection";

const iOSApps = () => {
  const heroData = {
    title: "Premium iOS App Development",
    description: "Create outstanding iOS apps that delight Apple users and drive business success. We build native iOS experiences that leverage the full power of Apple's ecosystem.",
    image: img13,
    imageAlt: "iOS Apps",
    features: [
      "Native Swift/SwiftUI",
      "Apple HIG compliant",
      "Universal app support",
      "Apple ecosystem integration",
      "Premium performance",
      "App Store optimization",
    ],
    pillars: [
      "Native performance that feels instantly responsive and fluid",
      "Beautiful design that follows Apple's standards and user expectations",
      "Deep integration with Apple services for premium experiences",
    ],
  };

  const journeySteps = [
    {
      title: "Discovery & Planning",
      description: "We analyze your target iOS users, business objectives, and App Store strategy to create a comprehensive development roadmap.",
      details: ["Business objectives", "User research", "App Store strategy", "Feature prioritization", "Tech stack selection", "Timeline planning"],
    },
    {
      title: "iOS Design",
      description: "Our designers craft beautiful interfaces following Apple's Human Interface Guidelines for native iOS experiences users expect.",
      details: ["Design system", "Wireframes", "High-fidelity mockups", "Apple HIG compliance", "Interactive prototypes", "Accessibility features"],
    },
    {
      title: "Swift Development",
      description: "We build performant iOS apps using Swift and SwiftUI, leveraging Apple's frameworks and APIs for optimal functionality.",
      details: ["Swift architecture", "SwiftUI interfaces", "API integration", "Core Data & CloudKit", "Performance tuning", "Security implementation"],
    },
    {
      title: "App Store Launch",
      description: "From beta testing with TestFlight to App Store submission, we ensure smooth approval and successful launch.",
      details: ["TestFlight beta", "Device testing", "App Store assets", "Submission review", "Launch monitoring", "Post-launch support"],
    },
  ];

  const capabilities = [
    {
      title: "Native iOS Development",
      content:
        "High-quality native apps built with Swift that take full advantage of iOS capabilities and deliver exceptional performance.",
    },
    {
      title: "SwiftUI Interfaces",
      content:
        "Modern, declarative UI development with SwiftUI for beautiful, responsive interfaces across all Apple devices.",
    },
    {
      title: "Apple Ecosystem",
      content:
        "Integration with iCloud, Apple Pay, HealthKit, ARKit, and other Apple services for rich, native experiences.",
    },
    {
      title: "Universal Apps",
      content:
        "Apps optimized for iPhone, iPad, Apple Watch, and Apple TV, providing consistent experiences across devices.",
    },
  ];

  const resultsData = {
    metrics: [
      { value: "4.8+", label: "Average App Store rating" },
      { value: "90%", label: "User retention (30 days)" },
      { value: "100%", label: "App Store approval rate" },
    ],
    description: "We deliver iOS apps that achieve exceptional App Store ratings, high user retention, and strong business results through quality and performance.",
  };

  const outcomesData = {
    description: "We create premium iOS apps that exemplify Apple's design philosophy and engineering excellence, delivering experiences that iOS users love.",
    outcomes: [
      "Native Swift/SwiftUI development",
      "Apple Human Interface Guidelines compliance",
      "Multiple device support (iPhone, iPad, Watch)",
      "iCloud sync and Apple service integration",
      "Push notifications and background tasks",
      "App Store optimization and marketing",
    ],
  };

  const whyChooseUs = [
    {
      title: "iOS Specialists",
      content:
        "Our team specializes in iOS development, staying at the forefront of Swift, SwiftUI, and Apple's latest technologies.",
    },
    {
      title: "Design Excellence",
      content:
        "We create pixel-perfect interfaces that follow Apple's design principles and delight iOS users.",
    },
    {
      title: "App Store Success",
      content:
        "Our apps consistently achieve high ratings and positive reviews with optimized App Store presence.",
    },
    {
      title: "Performance First",
      content:
        "We prioritize app performance, battery efficiency, and smooth animations for premium iOS experiences.",
    },
  ];

  const faqs = [
    {
      q: "How long does it take to develop an iOS app?",
      a: "Development timeline varies based on complexity, but typically ranges from 3-6 months for a standard app. We provide detailed timelines during the planning phase based on your specific requirements and features.",
    },
    {
      q: "Do you develop apps in Swift or SwiftUI?",
      a: "We primarily use Swift and SwiftUI for modern iOS development, taking advantage of Apple's latest frameworks. For legacy projects, we also work with Objective-C when needed.",
    },
    {
      q: "Can you help with App Store submission and approval?",
      a: "Yes! We handle the complete App Store submission process, including creating app store assets, writing descriptions, and managing the review process. We have a 100% approval rate.",
    },
    {
      q: "Do you provide post-launch support and updates?",
      a: "Absolutely. We offer ongoing maintenance, bug fixes, feature updates, and iOS version compatibility updates to ensure your app continues to perform excellently over time.",
    },
  ];

  return (
    <Fragment>
      <div className="br-app">
        <div id="page" className="page">
          <Header />
          <PageTitle
            pageTitle={"iOS App Development"}
            pagesub={"Web & App Development"}
          />
          <main className="page_content service-detials">
            <section className="pt-130 pb-130 gray-bg">
              <div className="container">
                <ServiceHero {...heroData} />
                <ServiceJourney title="Our iOS App Creation Journey" steps={journeySteps} />
                <ServiceCapabilities capabilities={capabilities} />
                <ServiceResults {...resultsData} />
                <ServiceOutcomes {...outcomesData} />
                <ServiceWhyChooseUs items={whyChooseUs} />
                <FaqSection faqs={faqs} />
              </div>
            </section>
          </main>
          <Footer />
          <Scrollbar />
        </div>
      </div>
    </Fragment>
  );
};

export default iOSApps;
